import React from 'react';

import CoverSheet from '../general/coverSheet';
import DyePenetrantInspection from './dyePenetrantInspection';
import ETAnomalyPDF from '../et/ETAnomalyPDF';
import PDFInfoSheet from '../../../themed/pdf/pdfInfoSheet';
import PDFPage from '../../../themed/pdf/pdfPage';
import PDFPhotoPage from '../../../themed/pdf/pdfPhotoPage';

import withPDF from '../../../hoc/withPDF';

import * as data from '../../../../utils/data';
import * as models from '../../../../utils/models';
import * as utils from '../../../../utils/utilities';

interface AutReportProps {
	anomalyData: models.VTEquipmentAnomalyData[];
	coverSheetData: models.DptCoverSheetProps;
	projectDetails: models.Project;
	photoRecords: models.PDFImageProps[];
	dyePenetrantInspection: models.DyePenetrantInspectionProps;
}

const DPTReport = (props: AutReportProps): JSX.Element => {
	const standardCriteriaItems: models.CoverDataItem[] = [
		{
			label: '1. Qualification of NDT Personnel',
			value: props.coverSheetData?.ndtQualification,
		},
		{
			label: '2. Non Destructive Testing',
			value: props.coverSheetData?.destructiveTesting,
		},
		{
			label:
				'3. Damage Mechanisms affecting Fixed Equipment in the Refining Industry',
			value: props.coverSheetData?.damageMechanisms,
		},
	];

	const referenceDocuments: models.CoverDataItem[] = [
		{
			label: '1. Scope Of Work',
			value: props.coverSheetData?.scopeOfWork,
		},
		{
			label: '2. Visual Examination Procedure',
			value: props.coverSheetData?.visualExaminationProcedure,
		},
		{
			label: '3. Dye Penetrant Examination Procedure',
			value: props.coverSheetData?.dyeExaminationProcedure,
		},
	];

	const photoRecords = utils.getChunkedData(props.photoRecords, 4);

	return (
		<React.Fragment>
			<PDFInfoSheet
				companyUrl={props.projectDetails.organisation.organisationLogo}
				documentNo={props.projectDetails.documentNumber}
				clientName={props.projectDetails.organisationName}
				facility={props.projectDetails.facilityName}
				reportTitle={props.projectDetails.projectTitle}
			/>

			<PDFPage
				pageDetails={utils.getPageDetails('Cover Sheet')}
				projectDetails={props.projectDetails}
			>
				<CoverSheet
					overviewData={overviewData}
					referenceDocuments={referenceDocuments}
					standardCriteriaItems={standardCriteriaItems}
				/>
			</PDFPage>

			<PDFPage
				pageDetails={utils.getPageDetails('Dye Penetrant Inspection')}
				projectDetails={props.projectDetails}
			>
				<DyePenetrantInspection
					{...props.dyePenetrantInspection}
					projectDetails={props.projectDetails}
					columns={data.getLPTColumns()}
				/>
			</PDFPage>

			<ETAnomalyPDF data={props.anomalyData} project={props.projectDetails} />

			{photoRecords.map((records: models.PDFImageProps[], index: number) => (
				<PDFPage
					key={index.toString()}
					pageDetails={utils.getPageDetails('Photographic Records')}
					projectDetails={props.projectDetails}
					enableTitlePage={index === 0}
				>
					<PDFPhotoPage photos={records} />
				</PDFPage>
			))}
		</React.Fragment>
	);
};

const overviewData: models.CoverDataOverview[] = [
	{ report: '1. Cover Sheet', required: 'Yes', page: '2' },
	{ report: '2. Dye Penetrant Inspection', required: 'Yes', page: '4' },
	{ report: '3. Anomaly Data', required: 'Yes', page: '6' },
	{ report: '4. Photographic Record', required: 'Yes', page: '8' },
];

export default withPDF(DPTReport);
